<template>
    <CicPopup
        :save-button-label="$t('Export')"
        saveable
        title="Export Access Numbers"
        @blur="$emit('blur')"
        @input="$emit('input', option)"
    >
        <CicRadioGroup
            :value="option"
            :options="[
                { value: 'selected', label: $t('Export Selected Numbers') },
                { value: 'all', label: $t('Export All Numbers') },
            ]"
            class="vertical"
            @input="(val) => (option = val)"
        />
    </CicPopup>
</template>

<script>
    import CicPopup from '@/components/CicPopup';
    import CicRadioGroup from '@/components/inputs/CicRadioGroup';

    export default {
        name: 'ExportAccessPoints',
        components: {
            CicRadioGroup,
            CicPopup,
        },
        emits: ['blur', 'input'],
        data() {
            return {
                option: 'selected',
            };
        },
    };
</script>
